import { QueryKeys } from '../../../enums/queryKeys'
import { BillsQueryProps } from '../types/billsQueryProps'

export const getBillsQueryKey = (queryProps: BillsQueryProps): [QueryKeys, BillsQueryProps] => [
  QueryKeys.Bills,
  queryProps,
]
